import React from 'react';
import './About.css';
import { useLanguage } from '../../i18n/LanguageContext';
import img2Q2A9656Copia1 from '../../../assets/about/Pic.png';

const About = () => {
  const { t } = useLanguage();
  return (
    <section className="about" data-name="About" data-node-id="5:436">
      <div className="about__container" data-name="Container" data-node-id="5:437">
        {/* Header */}
        <div className="about__header" data-name="Row" data-node-id="5:438">
          <div className="about__header-inner" data-name="Row" data-node-id="5:439">
            <div className="about__tag" data-name="Tag" data-node-id="5:440">
              <p className="about__tag-text">{t('about.tag')}</p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="about__content-row" data-name="Row" data-node-id="5:441">
          {/* Left Column - Image */}
          <div className="about__column about__column--image" data-name="Column" data-node-id="5:442">
            <div className="about__pic-container" data-name="Pic Container" data-node-id="5:443">
              <div className="about__pic-background" data-name="Background" data-node-id="5:444"></div>
              <div className="about__pic" data-name="Pic" data-node-id="5:445">
                <img src={img2Q2A9656Copia1} alt="About" className="about__pic-img" data-node-id="11:780" />
              </div>
            </div>
          </div>

          {/* Right Column - Text */}
          <div className="about__column about__column--text" data-name="Column" data-node-id="5:446">
            <h2 className="about__title" data-node-id="5:447">
              {t('about.title')}
            </h2>

            <div className="about__text-content" data-name="Content" data-node-id="5:448">
              <p className="about__text" data-node-id="5:449">
                {t('about.paragraph1')}
              </p>

              <p className="about__text" data-node-id="5:450">
                {t('about.paragraph2')}
              </p>

              <p className="about__text" data-node-id="5:451">
                {t('about.paragraph3')}
              </p>

              <p className="about__text" data-node-id="5:452">
                {t('about.paragraph4')}
              </p>

              <p className="about__text about__text--last" data-node-id="5:453">
                {t('about.paragraph5')}
              </p>

              {/* Checklist */}
              <div className="about__checklist" data-name="Checklist" data-node-id="5:454">
                <div className="about__checklist-column" data-name="Column" data-node-id="5:455">
                  <ul className="about__checklist-list" data-node-id="5:456">
                    <li>• {t('about.checklist1')}</li>
                  </ul>
                  <ul className="about__checklist-list" data-node-id="5:457">
                    <li>• {t('about.checklist2')}</li>
                  </ul>
                </div>
                <div className="about__checklist-column" data-name="Column" data-node-id="5:458">
                  <ul className="about__checklist-list" data-node-id="5:459">
                    <li>• {t('about.checklist3')}</li>
                  </ul>
                  <ul className="about__checklist-list" data-node-id="5:460">
                    <li>• {t('about.checklist4')}</li>
                  </ul>
                </div>
              </div>

              <p className="about__text" data-node-id="5:461">
                {t('about.closingText')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
